import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { usePageData } from '../../pages/BookAppointment/context/PageDataContext.js';
import Header$1 from './Header.js';

const HeaderContainer = (_param)=>{
    var { hasNavigation  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "hasNavigation"
    ]);
    const { logo  } = usePageData();
    const { getLabel  } = useIntl();
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
    return /*#__PURE__*/ React.createElement(Header$1, swcHelpers.extends({}, rest, {
        isMobile: isMobile,
        logo: logo,
        hasNavigation: hasNavigation,
        title: getLabel('appointments.component.headerContainer.linkTitle'),
        srOnlyText: getLabel('appointments.component.headerContainer.linkTitle')
    }));
};
var Header = HeaderContainer;

export { Header as default };
//# sourceMappingURL=HeaderContainer.js.map
